
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews/[identifier]",
      function () {
        return require("private-next-pages/reviews/[identifier].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews/[identifier]"])
      });
    }
  